import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetTapToBorrowSupportByCountryQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetTapToBorrowSupportByCountryQuery = { __typename?: 'Query', getTapToBorrowSupportByCountry: { __typename?: 'TapToBorrowSupportByCountry', countries_enabled_for_stripe_payment_intent: Array<string>, countries_enabled_for_stripe_setup_intent: Array<string>, countries_enabled_for_stripe_setup_intent_incl_pi_fallback: Array<string>, countries_enabled_for_stripe_payment_intent_and_pay: Array<string>, countries_enabled_for_stripe_payment_intent_and_pay_saved_card: Array<string> } };


export const GetTapToBorrowSupportByCountryDocument = gql`
    query GetTapToBorrowSupportByCountry {
  getTapToBorrowSupportByCountry {
    countries_enabled_for_stripe_payment_intent
    countries_enabled_for_stripe_setup_intent
    countries_enabled_for_stripe_setup_intent_incl_pi_fallback
    countries_enabled_for_stripe_payment_intent_and_pay
    countries_enabled_for_stripe_payment_intent_and_pay_saved_card
  }
}
    `;

/**
 * __useGetTapToBorrowSupportByCountryQuery__
 *
 * To run a query within a React component, call `useGetTapToBorrowSupportByCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTapToBorrowSupportByCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTapToBorrowSupportByCountryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTapToBorrowSupportByCountryQuery(baseOptions?: Apollo.QueryHookOptions<GetTapToBorrowSupportByCountryQuery, GetTapToBorrowSupportByCountryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTapToBorrowSupportByCountryQuery, GetTapToBorrowSupportByCountryQueryVariables>(GetTapToBorrowSupportByCountryDocument, options);
      }
export function useGetTapToBorrowSupportByCountryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTapToBorrowSupportByCountryQuery, GetTapToBorrowSupportByCountryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTapToBorrowSupportByCountryQuery, GetTapToBorrowSupportByCountryQueryVariables>(GetTapToBorrowSupportByCountryDocument, options);
        }
export type GetTapToBorrowSupportByCountryQueryHookResult = ReturnType<typeof useGetTapToBorrowSupportByCountryQuery>;
export type GetTapToBorrowSupportByCountryLazyQueryHookResult = ReturnType<typeof useGetTapToBorrowSupportByCountryLazyQuery>;
export type GetTapToBorrowSupportByCountryQueryResult = Apollo.QueryResult<GetTapToBorrowSupportByCountryQuery, GetTapToBorrowSupportByCountryQueryVariables>;